import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import TimeFormat from '@/components/TimeFormat';

const useStyles = makeStyles(theme => ({
  table: props => ({
    minWidth: props.isFinal ? 750 : 400,
  }),
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}));


const GoalieBoxscore = ({ goalies, isFinal }) => {
  const classes = useStyles(isFinal);
  return (
    <TableContainer>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            { isFinal && (
              <TableCell align="right">Record</TableCell>
            )}
            <TableCell align="right">Saves</TableCell>
            <TableCell align="right">Shots</TableCell>
            <TableCell align="right">SV%</TableCell>
            { isFinal && (
              <TableCell align="right">TOI</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          { goalies.map(goalie => (
            <TableRow key={goalie.id} className={classes.row}>
              <TableCell component="th" scope="row">
                {goalie.name}
              </TableCell>
              { isFinal && (
                <TableCell align="right">
                  { goalie.decision ?
                    `${goalie.decision}, ${goalie.wins}-${goalie.loss}-${goalie.otl}`
                    : ''
                  }
                </TableCell>
              )}
              <TableCell align="right">{goalie.saves}</TableCell>
              <TableCell align="right">{goalie.shots}</TableCell>
              <TableCell align="right">
               { `${(goalie.shots === 0 ? 0 : (goalie.saves / goalie.shots)).toFixed(3)}%` }
              </TableCell>
              { isFinal && (
                <TableCell align="right">
                  <TimeFormat time={goalie.toi} />
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}


export default GoalieBoxscore;